<modal [isOpen]="statusModal.statusModal">
  <div class="primary-modal" [ngClass]="{ 'primary-modal-create': statusModal.type !== 'reset' }">
    <div class="header">
      <header-modal
        [title]="
          statusModal.type === 'reset' ? translate.title : translate.title2
        "
        (action)="close()"
      ></header-modal>
    </div>
    <div class="primary-modal__content-loading" *ngIf="isLoading">
      <mg-loading [loading]="true"></mg-loading>
    </div>
    <div class="primary-modal__content-modal" *ngIf="!isLoading">
      <div class="primary-modal__content-modal__text">
        <span
          class="primary-modal__content-modal__text__description"
          *ngIf="!typeResend && statusModal.type === 'reset'"
        >
          {{
            statusModal.text?.length || 0 > 0
              ? statusModal.text
              : translate.messageReset
          }}
        </span>
        <span
          class="primary-modal__content-modal__text__description"
          *ngIf="typeResend && statusModal.type === 'reset'"
        >
          {{ translate.messageCheck }}
        </span>
        <span
          class="primary-modal__content-modal__text__description"
          *ngIf="statusModal.type === 'create'"
          >{{ translate.messageComplet }}</span
        >
      </div>
      <div class="primary-modal__content-modal__content-action">
        <div
          class="primary-modal__content-modal__content-action__username"
          *ngIf="!typeResend && statusModal.type === 'reset'"
        >
          <div
            class="primary-modal__content-modal__content-action__username__form form-group"
          >
            <label for="username"> {{ translate.username }} </label>
            <input
              type="text"
              class="input-mg-app"
              id="username"
              name="username"
              [(ngModel)]="username"
              [placeholder]="translate.usernamePlaceholder"
            />
          </div>
        </div>
        <div
          *ngIf="typeResend && statusModal.type === 'reset'"
          class="primary-modal__content-modal__content-action__reset"
        >
          <code-input
            [isCodeHidden]="false"
            [codeLength]="4"
            [initialFocusField]="0"
            (codeChanged)="onCodeChanged($event)"
            (codeCompleted)="onCodeCompleted($event)"
          >
          </code-input>
          <span class="error" *ngIf="isInvalidCode">
            {{ translate.invalidCode }}
          </span>
          <div
            class="primary-modal__content-modal__content-action__reset__time-caducation"
          >
            <span> {{ translate.expire }} </span>
            <span *ngIf="minutes.toString().length === 1">0</span>
            <span>{{ minutes }}</span>
            <span>:</span>
            <span *ngIf="seconds.toString().length === 1">0</span>
            <span>{{ seconds }}</span>
          </div>
        </div>
        <div
          class="primary-modal__content-modal__content-action__email"
          *ngIf="statusModal.type === 'create'"
        >
          <div
            class="primary-modal__content-modal__content-action__email__form form-group"
          >
            <label for="email"> {{ translate.newPassword }} </label>
            <mg-input-password
              [placeholder]="'********'"
              (valueInput)="dataPassword($event)"
            >
            </mg-input-password>
          </div>
          <div class="form-group">
            <label for="confirmPassword">{{ translate.confirmPassword }}</label>
            <mg-input-password
              [placeholder]="'********'"
              (valueInput)="dataConfirmPassword($event)"
            >
            </mg-input-password>
            <span class="error" *ngIf="isInvalidPassword">
              {{ translate.passwordNotMatch }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-modal">
      <button
        class="secundaryButton"
        (click)="reSend()"
        [disabled]="minutes !== '00' || seconds !== '00' || isResend"
        *ngIf="typeResend && statusModal.type === 'reset'"
      >
        <span> {{ translate.buttonresend }} </span>
      </button>
      <button
        class="primaryButton"
        (click)="send()"
        [disabled]="
          typeResend
            ? this.code.length != 4
              ? true
              : false
            : this.username.length != 0
            ? false
            : true
        "
        *ngIf="statusModal.type === 'reset'"
      >
        <span>
          {{ typeResend ? translate.buttonCheck : translate.buttonSend }}
        </span>
      </button>
      <button
        class="primaryButton"
        (click)="complet()"
        [disabled]="
          isInvalidPassword ||
          this.password.length < 4 ||
          this.password.length < 4
        "
        *ngIf="statusModal.type === 'create'"
      >
        <span> {{ translate.buttonComplet }} </span>
      </button>
    </div>
  </div>
</modal>
